import React from 'react';
import { X, Info, CreditCard } from "lucide-react";

const PointsModal = ({ onClose }) => {
    return (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-in fade-in duration-300" onClick={onClose}>
        <div className="bg-white rounded-[2rem] w-full max-w-sm overflow-hidden shadow-2xl relative" onClick={e => e.stopPropagation()}>
          <div className="bg-gradient-to-r from-slate-700 to-slate-800 p-6 text-white relative">
              <button onClick={onClose} className="absolute top-4 right-4 p-2 bg-white/10 rounded-full hover:bg-white/20 transition-all">
                   <X size={18} className="text-white"/>
              </button>
              <div className="flex items-center gap-3 mb-1">
                  <Info size={32} className="text-white fill-white/20"/>
                  <h3 className="text-2xl font-black tracking-wide">點數功能</h3>
              </div>
               <p className="text-white/60 text-xs font-bold ml-1">Points System</p>
          </div>
          <div className="p-8 space-y-6 text-center">
              <div className="w-20 h-20 bg-slate-100 rounded-full mx-auto flex items-center justify-center mb-2">
                  <CreditCard size={40} className="text-slate-400"/>
              </div>
              <div>
                  <h4 className="text-lg font-black text-slate-800 mb-2">功能建置中</h4>
                  <p className="text-slate-500 text-sm leading-relaxed font-medium">
                      目前點數系統正在進行最後測試。<br/>
                      若您有點數相關問題，或希望了解更多，<br/>
                      請直接<strong className="text-orange-600 underline cursor-pointer">聯繫老師</strong>。
                  </p>
              </div>
              <div className="bg-orange-50 p-4 rounded-xl text-xs text-orange-600/80 border border-orange-100 font-bold">
                  感謝您的支持，我們將持續優化學習體驗。
              </div>
              <button onClick={onClose} className="w-full py-3 bg-slate-800 text-white font-bold rounded-xl hover:bg-slate-700 transition-all active:scale-95">
                  我知道了
              </button>
          </div>
        </div>
      </div>
    );
};

export default PointsModal;
